import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons";

import { PatientKind } from "common/types";
import Image from "common/components/Image";
import Icon from "common/components/Icon";

import SelectButton from "client/common/components/buttons/SelectButton";

import { imageForSpecies } from "../utils";
import { useAccountCreatePetDrawer } from "../stackables";

import styles from "../styles/PatientMultiSelectPanel.module.less";

export type PatientForMultiSelectPanel = {
  id: number;
  name_display: string;
  species: PatientKind;
  species_display: string;
};

type PatientMultiSelectPanelProps = {
  values: PatientForMultiSelectPanel[];
  onChange: (values: PatientForMultiSelectPanel[]) => void;
  options: PatientForMultiSelectPanel[];
  hasAdd?: boolean;
};

const PatientMultiSelectPanel = ({
  values,
  onChange,
  options,
  hasAdd = true,
}: PatientMultiSelectPanelProps) => {
  const { open: openCreatePet } = useAccountCreatePetDrawer();

  const selectedIds = new Set(values.map((value) => value.id));
  const resultIds = new Set(options.map((option) => option.id));
  const selectedNotInResults = values.filter((value) => !resultIds.has(value.id));
  const displayedOptions = [...selectedNotInResults, ...options];

  const handleClick = (clicked: PatientForMultiSelectPanel) => {
    if (selectedIds.has(clicked.id)) {
      onChange(values.filter((value) => value.id !== clicked.id));
      return;
    }
    onChange([...values, clicked]);
  };

  return (
    <div className={styles.container}>
      {displayedOptions.map((option) => (
        <SelectButton
          align="center"
          key={option.id}
          isActive={selectedIds.has(option.id)}
          onClick={() => handleClick(option)}
          renderContent={({ isActive }) => (
            <div className={styles.content}>
              <span className={styles.petName}>{option.name_display}</span>
              <Image src={imageForSpecies(option.species, isActive)} alt={option.species_display} />
            </div>
          )}
        />
      ))}
      {hasAdd && (
        <SelectButton
          align="center"
          className={styles.addOption}
          onClick={() =>
            openCreatePet({
              onSuccess: (patient) => onChange([...values, patient]),
            })
          }
          isActive={false}
          disabled={false}
          renderContent={() => (
            <div className={styles.addPet}>
              <Icon icon={faPlusCircle} />
              Add new pet
            </div>
          )}
        />
      )}
    </div>
  );
};

export default PatientMultiSelectPanel;
